import { useState } from "react";
import { ContactField } from "./ContactField";
import { ContactStatus } from "./ContactStatus";

type SubmitStatus = "idle" | "loading" | "success" | "error";

interface ContactPayload {
  name: string;
  fromEmail: string;
  message: string;
}

async function submitContact(payload: ContactPayload): Promise<void> {
  const lambdaUrl = (import.meta as Record<string, unknown> & { env?: Record<string, string> })
    .env?.BUN_PUBLIC_LAMBDA_URL;
  const url = lambdaUrl ?? "";
  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw new Error(`Request failed: ${response.status}`);
  }
}

export function ContactForm() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState<SubmitStatus>("idle");
  const [errorMessage, setErrorMessage] = useState("");

  async function handleSubmit() {
    if (!name.trim() || !email.trim() || !message.trim()) return;
    setStatus("loading");
    try {
      await submitContact({ name, fromEmail: email, message });
      setStatus("success");
    } catch (err) {
      setErrorMessage(err instanceof Error ? err.message : "Something went wrong.");
      setStatus("error");
    }
  }

  return (
    <div className="contact-form-content">
      <ContactField label="Your Name" value={name} onChange={setName} />
      <ContactField label="Your Email" type="email" value={email} onChange={setEmail} />
      <ContactField
        label="Your Message"
        type="textarea"
        value={message}
        onChange={setMessage}
        maxLength={500}
        charCount={message.length}
      />
      {status !== "success" && (
        <button className="form-button" onClick={handleSubmit} disabled={status === "loading"}>
          {status === "loading" ? "Sending…" : "Send Message"}
        </button>
      )}
      {status === "success" && <ContactStatus status="success" />}
      {status === "error" && <ContactStatus status="error" errorMessage={errorMessage} />}
    </div>
  );
}
